/*
* fn [function] 需要防抖的函数
* delay [number] 毫秒，防抖期限值
*/
export function debounce(fn, delay) {
    let delayTime = delay || 200;
    let timer = null;
    return function() {
        let _this = this;
        let args = arguments;
        if(timer) {
            clearTimeout(timer);
        }
        timer = setTimeout(function() {
            timer = null;
            fn.apply(_this, args);
        }, delayTime);
    }
}